<template>
  <div class="columns is-gapless">
    <div
      class="column is-3 is-3-desktop is-3-widescreen is-block"
      :class="isMenuVisible ? '' : 'is-hidden'"
      style="
        max-width: 350px;
        border-style: solid;
        border-width: 0px 1px 0px 0px;
        border-color: rgb(172, 136, 86);
        height: calc(100vh - 25px);
        overflow-y: auto;
      "
    >
      <Menu />
    </div>
    <div
      class="column"
      style="height: calc(100vh - 25px); overflow-y: auto; overflow-x: hidden"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Menu from '@/components/Menu.vue';

export default {
  name: 'IndexMain',
  components: {
    Menu,
  },
  computed: {
    ...mapGetters({
      isMenuVisible: 'isMenuVisible',
    }),
  },
};
</script>
